import { useState } from 'react'
import { ApiHatasi, api, type Kullanici } from '../api'

export function Giris({ onGiris }: { onGiris: (k: Kullanici) => void }) {
  const [eposta, setEposta] = useState('')
  const [parola, setParola] = useState('')
  const [hata, setHata] = useState<string | null>(null)
  const [bekliyor, setBekliyor] = useState(false)
  /**
   * Oturum limitine takıldık mı.
   *
   * Takılınca kullanıcıya ÇIKIŞ YOLU gösteriliyor. Eskiden yalnızca
   * "başka bir cihazdan çıkış yapın ya da yöneticinizden yardım
   * isteyin" yazıyordu: elindeki tek cihaz buysa yapabileceği bir
   * şey yoktu, çünkü oturum kapatma uçları girişin arkasında.
   */
  const [limit, setLimit] = useState<{ acik: number; limit: number } | null>(null)

  const gonder = async (e: React.FormEvent, digerleriniKapat = false) => {
    e.preventDefault()
    setHata(null)
    setBekliyor(true)
    try {
      const r = await api.giris(eposta.trim(), parola, digerleriniKapat)
      setLimit(null)
      onGiris(r.kullanici)
    } catch (err) {
      /**
       * Hata mesajları ayrım yapmıyor.
       *
       * "Bu e-posta kayıtlı değil" demek, kimin sistemde olduğunu
       * sızdırır. Sunucu da aynı cevabı veriyor; burada da öyle.
       */
      if (err instanceof ApiHatasi && err.kod === 'oturum_limiti') {
        const g = (err.govde ?? {}) as { acik?: number; limit?: number }
        setLimit({ acik: Number(g.acik ?? 0), limit: Number(g.limit ?? 0) })
      } else {
        /*
         * Oturum limiti dışındaki her şey AYNI mesaj. "Bu e-posta
         * kayıtlı değil" demek, kimin sistemde olduğunu sızdırır.
         * Limit mesajı bunu sızdırmıyor: oraya ancak parola DOĞRU
         * olduğunda düşülüyor, yani bilgi zaten kullanıcının.
         */
        setLimit(null)
        setHata('E-posta veya parola hatalı.')
      }
    } finally {
      setBekliyor(false)
    }
  }

  return (
    <div className="giris">
      <h1>Nirengi</h1>
      <p className="alt">Uygulayıcı paneli</p>
      <form className="kart" onSubmit={gonder}>
        {hata && <div className="uyari">{hata}</div>}
        {limit && (
          <div className="uyari">
            Bu hesapta {limit.acik} cihazda oturum açık ({limit.limit} sınırı doldu).
            Çalışan bir oturumu kendiliğinden kapatmıyoruz — seans ortasındaki bir
            uygulayıcının oturumunu arkadan düşürmek veri kaybı demek.
            <div style={{ marginTop: 8 }}>
              <button
                type="button"
                disabled={bekliyor}
                onClick={(e) => void gonder(e, true)}
              >
                Diğer cihazlardaki oturumları kapat ve gir
              </button>
            </div>
          </div>
        )}
        <label>
          E-posta
          <input
            type="email"
            autoComplete="username"
            value={eposta}
            onChange={(e) => setEposta(e.target.value)}
            required
          />
        </label>
        <label>
          Parola
          <input
            type="password"
            autoComplete="current-password"
            value={parola}
            onChange={(e) => setParola(e.target.value)}
            required
          />
        </label>
        <button className="birincil" type="submit" disabled={bekliyor} style={{ width: '100%' }}>
          {bekliyor ? 'Giriliyor…' : 'Giriş'}
        </button>
      </form>
      <p className="alt" style={{ textAlign: 'center' }}>
        Sağlık verisi tutan bir sistemdesiniz. Ortak kullanılan bir cihazda işiniz bitince
        çıkış yapın.
      </p>
    </div>
  )
}
